export enum rxReceivedScreenView {
  cart = 0,
  patientData = 1,
  shipping = 2,
  subscriptionOffer = 3,
  payment = 4,
  success = 5,
}

export enum rxEstimateScreenView {
  cart = 0,
  signup = 1,
  chooseSubscription = 2,
  basicinfo = 3,
}
